import {
  apiInstance_ecom,
  globalAPIInstance,
} from "@/app/api-config/axios-instance";
import { createQueryString } from "@/app/utils/utility";

// fetch the list of expense
export const getAddressList = async (payload) => {
  try {
    const resposne = await apiInstance_ecom.get(
      `/addressList${createQueryString(payload)}`,
      {
        skipLoader: true,
      }
    );
    if (resposne.status == 200) {
      return {
        status: true,
        data: resposne.data,
      };
    } else {
      return { status: false, data: [] };
    }
  } catch (err) {
    return { status: false, data: [] };
  }
};

export const addAddress = async (payload) => {
  try {
    const resposne = await apiInstance_ecom.post(`/addAddress`, payload, {
      skipLoader: true,
    });
    if (resposne.status == 200) {
      return { status: true };
    } else {
      return { status: false };
    }
  } catch (err) {
    return { status: false };
  }
};

export const editAddress = async (payload) => {
  try {
    const resposne = await apiInstance_ecom.put(`/updateAddress`, payload, {
      skipLoader: true,
    });
    if (resposne.status == 200) {
      return { status: true };
    } else {
      return { status: false };
    }
  } catch (err) {
    return { status: false };
  }
};

export const addressDelete = async (payload) => {
  try {
    const resposne = await apiInstance_ecom.delete(
      `/removeAddress${createQueryString(payload)}`,
      {
        skipLoader: true,
      }
    );
    if (resposne.status == 200) {
      return { status: true };
    } else {
      return { status: false };
    }
  } catch (err) {
    return { status: false };
  }
};

export const getCountryList = async () => {
  try {
    const resposne = await globalAPIInstance.get(`/logistics/listOfCountries`, {
      skipLoader: true,
    });

    if (resposne.status == 200) {
      return {
        status: true,
        data: resposne.data.rows,
      };
    } else {
      return { status: false, data: [] };
    }
  } catch (err) {
    return { status: false, data: [] };
  }
};

export const getStateList = async (payload) => {
  try {
    const resposne = await globalAPIInstance.get(
      `/logistics/listOfStatesOfSpecificCountry${createQueryString(payload)}`,
      {
        skipLoader: true,
      }
    );
    if (resposne.status == 200) {
      return {
        status: true,
        data: resposne.data,
      };
    } else {
      return { status: false, data: [] };
    }
  } catch (err) {
    return { status: false, data: [] };
  }
};
